import clothingMap from './clothes/clothing-map.json';

export const PRESET_SIZES = {
	sm: { w: 80, h: 80 },
	md: { w: 200, h: 200 },
	lg: { w: 400, h: 400 },
} as const;

export const EXTENSION = 'png';

export const CONTENTS = [] as const;

type ClothingMap = Record<string, string>;

/**
 * Получает путь к изображению одежды из мапы по ID
 * @param id - ID одежды
 * @returns Путь к изображению без расширения или null, если ID не найден
 */
export const getClothesImagePathFromMap = (id: string): string | null => {
	const map = clothingMap as ClothingMap;
	const path = map[id];

	if (!path) {
		return null;
	}

	const normalizedPath = path.replace(/\\/g, '/');

	const pathWithoutExtension = normalizedPath.replace(/\.png$/, '');

	return pathWithoutExtension;
};

/**
 * @deprecated Используйте getClothesImagePathFromMap вместо этого
 * Парсит ID одежды и возвращает структурированные части пути
 */
export const parseClothesId = (
	id: string,
): {
	category: string;
	subcategory: string;
	item: string;
	variant: string;
} | null => {
	const parts = id.split('_');

	if (parts.length < 4) {
		return null;
	}

	let category: string;
	let subcategory: string;
	let item: string;
	let variant: string;

	if (parts[0] === 'all' && parts[1] === 'clothes') {
		category = 'all_clothes';
		subcategory = parts[2];
		variant = parts[parts.length - 1];
		const itemParts = parts.slice(3, -1);
		item = itemParts.join('_');
	} else {
		category = parts[0];
		subcategory = parts[1];
		variant = parts[parts.length - 1];
		const itemParts = parts.slice(2, -1);
		item = itemParts.join('_');
	}

	return {
		category,
		subcategory,
		item,
		variant,
	};
};

/**
 * @deprecated Используйте getClothesImagePathFromMap вместо этого
 * Получает структурированный путь к изображению одежды на основе парсинга ID
 */
export const getClothesImagePath = (
	id: string,
): {
	category: string;
	subcategory: string;
	item: string;
	variant: string;
} | null => {
	const parsed = parseClothesId(id);

	if (!parsed) {
		return null;
	}

	const { category, subcategory, item, variant } = parsed;

	return { category, subcategory, item, variant };
};
